/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:3aa839f9-ed4d-4622-979c-e858d260ead4",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_gse8DzBFv",
    "aws_user_pools_web_client_id": "6ra7shsls6ro313l2snoae7er1",
    "oauth": {
        "domain": "ratemydisease-dev.auth.us-east-2.amazoncognito.com",
        "scope": [
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://ratemydisease.com/,http://localhost:9999/",
        "redirectSignOut": "https://ratemydisease.com/,http://localhost:9999/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
    "aws_appsync_graphqlEndpoint": "https://hn5ltfuyk5b4xn2ovuky5glyka.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "og",
            "endpoint": "https://d7278mkkig.execute-api.us-east-2.amazonaws.com/dev",
            "region": "us-east-2"
        },
        {
            "name": "echoapi",
            "endpoint": "https://ot3wgso2o5.execute-api.us-east-2.amazonaws.com/dev",
            "region": "us-east-2"
        }
    ]
};


export default awsmobile;
